export const FETCH_PROJECTS = 'FETCH_PROJECTS'
export const FETCH_PROJECTS_HOME = 'FETCH_PROJECTS_HOME'
export const FETCH_PROJECT_DETAILS = 'FETCH_PROJECT_DETAILS'
export const FETCH_PROJECTS_MORE = 'FETCH_PROJECTS_MORE'
export const FETCH_CLIENTS = 'FETCH_CLIENTS'
export const FETCH_ABOUT = 'FETCH_ABOUT'
export const SEND_CONTACTFORM_EMAIL = 'SEND_CONTACTFORM_EMAIL'
export const SEND_CONTACTFORM_EMAIL_ERROR = 'SEND_CONTACTFORM_EMAIL_ERROR'
export const ACCEPT_COOKIE = 'ACCEPT_COOKIE'